import React from 'react';
import style from './questionMarkCircle.module.scss';

export function QuestionMarkCircle(): JSX.Element {
    return (
        <span className={style.questionMarkCircle}>?</span>
    );
}
